import { Pipe, PipeTransform } from '@angular/core';

/** Pure pipe: avoids per-CD method calls in templates for stage labels. */
@Pipe({
  name: 'stageDisplayStatus',
  standalone: true,
  pure: true,
})
export class StageDisplayStatusPipe implements PipeTransform {
  transform(status: string | undefined): string {
    if (!status) return 'Not Started';
    switch (status.toLowerCase()) {
      case 'pending':
        return 'requested';
      case 'approved':
        return 'approved';
      case 'rejected':
        return 'rejected';
      case 'completed':
        return 'completed';
      default:
        return 'Not Started';
    }
  }
}

/** Pure pipe: CSS modifier class for summary status pills. */
@Pipe({
  name: 'stageOverviewStatusClass',
  standalone: true,
  pure: true,
})
export class StageOverviewStatusClassPipe implements PipeTransform {
  transform(status: string | undefined): string {
    const s = (status || '').toLowerCase();
    switch (s) {
      case 'pending':
        return 'stage-status-overview--requested';
      case 'approved':
        return 'stage-status-overview--approved';
      case 'rejected':
        return 'stage-status-overview--rejected';
      case 'completed':
        return 'stage-status-overview--completed';
      default:
        return 'stage-status-overview--neutral';
    }
  }
}
